/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { Subject, takeUntil, filter, take } from 'rxjs';

import { CoreMenuService } from '@xbaht/ui/core/components/core-menus/core-menu/services/core-menu.service';
import { CoreSidebarService } from '@xbaht/ui/core/components/core-sidebars/core-sidebar/services/core-sidebar.service';

import { CoreConfigService } from '@xbaht/ui/core/services';

@Component({
  selector: 'xbaht-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrl: './vertical-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class VerticalMenuComponent implements OnInit, OnDestroy {
  public coreConfig: any;
  public menu: any;
  public isCollapsed?: boolean;
  public isScrolled: boolean = false;

  private _unsubscribe: Subject<void>;

  constructor(
    private _coreConfigService: CoreConfigService,
    private _coreMenuService: CoreMenuService,
    private _coreSidebarService: CoreSidebarService,
    private _router: Router
  ) {
    this._unsubscribe = new Subject<void>();
  }

  ngOnInit(): void {
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config: any) => {
        this.coreConfig = config;
      });

    this.isCollapsed =
      this._coreSidebarService.getSidebarRegistry('menu')!.collapsed;

    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._unsubscribe)
      )
      .subscribe(() => {
        if (this._coreSidebarService.getSidebarRegistry('menu')) {
          this._coreSidebarService.getSidebarRegistry('menu')!.close();
        }
      });

    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        setTimeout(() => {
          // this.directiveRef.scrollToElement('.navigation .active', -180, 500);
        });
      });

    this._coreMenuService.onMenuChanged
      .pipe(
        filter((value) => value !== null),
        takeUntil(this._unsubscribe)
      )
      .subscribe(() => {
        this.menu = this._coreMenuService.getCurrentMenu();
      });
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  public onSidebarScroll(): void {
    // if (this.directiveRef.position(true).y > 3) {
    //   this.isScrolled = true;
    // } else {
    //   this.isScrolled = false;
    // }
  }

  public toggleSidebar(): void {
    this._coreSidebarService.getSidebarRegistry('menu')!.toggleOpen();
  }

  public toggleSidebarCollapsible(): void {
    this._coreConfigService
      .getConfig()
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((config) => {
        this.isCollapsed = config.layout.menu.collapsed;
      });

    if (this.isCollapsed) {
      this._coreConfigService.setConfig(
        { layout: { menu: { collapsed: false } } },
        { emitEvent: true }
      );
    } else {
      this._coreConfigService.setConfig(
        { layout: { menu: { collapsed: true } } },
        { emitEvent: true }
      );
    }
  }
}
